import Column from './Column';
import Row from './Row';

const Grid = {
    Column,
    Row,
}

export default Grid;
